import { api } from '@/lib/api'

/**
 * @returns {Promise<object>}
 */
export async function fetchPaymentGatewaySettings() {
  const { data } = await api.get('/masters/payment-gateway-settings')
  return data.data.payment_gateway
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<object>}
 */
export async function updatePaymentGatewaySettings(payload) {
  const { data } = await api.put('/masters/payment-gateway-settings', payload)
  return data.data.payment_gateway
}

/**
 * @param {number} saleId
 * @param {{ amount: number, card_last4?: string }} payload
 */
export async function chargeSaleGateway(saleId, payload) {
  const { data } = await api.post(`/sales/${saleId}/charge-gateway`, payload)
  return data.data
}

/**
 * @param {number} transactionId
 * @param {{ amount: number, manager_email: string, manager_password: string }} payload
 */
export async function refundGatewayTransaction(transactionId, payload) {
  const { data } = await api.post(`/gateway-transactions/${transactionId}/refund`, payload)
  return data.data
}

/**
 * @param {{ package_id: number, customer_id: number, count: number }} payload
 */
export async function generateGiftVoucherBatch(payload) {
  const { data } = await api.post('/masters/gift-voucher-batches', payload)
  return data.data
}
